import { render, staticRenderFns } from "./DownLoadPopup.vue?vue&type=template&id=77e23744"
import script from "./DownLoadPopup.vue?vue&type=script&lang=js"
export * from "./DownLoadPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports